/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Cat_Constructed_OnlineInputs */



/**
* | output |
* | --- |
* | "Constructed Online" |
*
* @param {Rankings_Cat_Constructed_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_cat_constructed_online = /** @type {((inputs?: Rankings_Cat_Constructed_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Cat_Constructed_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Construit en ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Constructed Online")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Constructed Online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Constructed Online")
	return /** @type {LocalizedString} */ ("Constructed Online")
});